import React from 'react';
import { Routes, Route } from "react-router-dom";
import Layout from "../Components/layout";
import ProtectedRoute from "./ProtectedRoutes"; // Import ProtectedRoute

import Dashboard from "../Pages/Dashboard";
import Login from "../Pages/login";
import Products from "../Pages/Products/listProducts";
import AddProducts from "../Pages/Products/addProducts";
import ViewProducts from "../Pages/Products/viewProducts";
import EditProducts from "../Pages/Products/editProducts";
import Home from "../Pages/content-management/home";
import About from "../Pages/content-management/about";
import AboutBannerEdit from "../Pages/content-management/about/banner/edit";
import AboutBannerView from "../Pages/content-management/about/banner/view";
import Contact from "../Pages/Contact";
import ContactInformation from "../Pages/Contact/contactInformation";

// category
import ListCategory from "../Pages/Category/list";
import AddCategory from "../Pages/Category/add";
import EditCategory from "../Pages/Category/edit";
import ViewCatgory from "../Pages/Category/view";

// brands
import ListBrands from "../Pages/Brands/list";
import AddBrands from "../Pages/Brands/add";
import EditBrands from "../Pages/Brands/edit";
import ViewBrands from "../Pages/Brands/view";

// settings
import GeneralSettings from "../Pages/GeneralSettings"
import FooterSettings from "../Pages/FooterSettings"


// orders
import ListOrder from "../Pages/Orders/list"
import ViewOrder from "../Pages/Orders/view"

// Customers
import ListCustomers from "../Pages/Customers/list"
import ViewCustomers from "../Pages/Customers/view"

// payment settings
import PaymentMethodList from "../Pages/PaymentSettings/list"
import PaymentMthodAdd from "../Pages/PaymentSettings/add"

// stock managemnt
import StockList from "../Pages/stock-management/list"
import StockAdd from "../Pages/stock-management/add"

// pages
import HomeBannerList from "../Pages/content-management/home/banner/list"
import HomeBannerEdit from "../Pages/content-management/home/banner/edit"
import HomeBannerAdd from "../Pages/content-management/home/banner/add"
import HomeBannerView from "../Pages/content-management/home/banner/view"

// banner
import OtherBannerList from "../Pages/content-management/OtherBanners/list"
import OtherBannerEdit from "../Pages/content-management/OtherBanners/edit"
import OtherbannerAdd from "../Pages/content-management/OtherBanners/add"
import OtherBannerView from "../Pages/content-management/OtherBanners/view"

// coupons
import CouponList from "../Pages/Coupons/list"
import AddCoupon from "../Pages/Coupons/add"
import EditCoupon from "../Pages/Coupons/edit"
import CouponView from "../Pages/Coupons/view"

// Home sections
import HomeSectionList from "../Pages/content-management/home/sections/list"
import HomeSectionAdd from "../Pages/content-management/home/sections/add"
import HomeSectionEdit from "../Pages/content-management/home/sections/edit"
import HomeSectionView from "../Pages/content-management/home/sections/view"


// about
import AboutSectionList from "../Pages/content-management/home/sections/list"
import AboutSectionAdd from "../Pages/content-management/about/section/add"
import AboutSectionEdit from "../Pages/content-management/home/sections/edit"
import AboutSectionView from "../Pages/content-management/home/sections/view"

// Contact
import ContactAdd from "../Pages/content-management/Contact/add"
import ProductDetailAdd from "../Pages/content-management/home/product-detail/add"

// Guestcheckout
import EnableGuestCheckout from "../Pages/GuestCheckOutSettings"
import AddBestSeller from "../Pages/content-management/home/best-seller"
import AddFeatured from "../Pages/content-management/home/featured"
import AddLatestProduct from "../Pages/content-management/home/latest-product"

import EditCustomer from "../Pages/Customers/edit"
import EnableDisableBrand from "../Pages/content-management/home/brand-section"
import PrivacyPolicy from "../Pages/content-management/privacy-policy"
import TermsandConditions from "../Pages/content-management/terms-and-condition"
import AdminProfileUpdate from "../Pages/admin-profile-update"
import ChangePassword from "../Pages/change-password"
import ForgotPassword from "../Pages/forgot-password"
import SendOTP from "../Pages/send-otp"
import ResetPassword from "../Pages/reset-password"
import OrderSettings from "../Pages/OrderSettings"
import AddVarients from "../Pages/add-varients/add"
import ListVarients from "../Pages/add-varients/list"
import EditVarients from "../Pages/add-varients/edit"

import AddVarientsbyProduct from "../Pages/add-variants-by-product/add"
import ListVarientsbyProduct from "../Pages/add-variants-by-product/list"
import EditVarientsbyProduct from "../Pages/add-variants-by-product/edit"


import RefundPolicy from "../Pages/content-management/refund-policy"
import ShippingPolicy from "../Pages/content-management/shipping-policy"
import Reports from "../Pages/reports"

import UpdateCurrency from "../Pages/update-currency"

function route() {
    return (
        <Routes>
            {/* Login Route (Accessible without token) */}
            <Route path="/login" element={<Login />} />

            {/* Protected Routes - Requires Access Token */}
            <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
            <Route path="/products" element={<ProtectedRoute><Layout><Products /></Layout></ProtectedRoute>} />
            <Route path="/add-products" element={<ProtectedRoute><Layout><AddProducts /></Layout></ProtectedRoute>} />
            <Route path="/view-products/:id" element={<ProtectedRoute><Layout><ViewProducts /></Layout></ProtectedRoute>} />
            <Route path="/edit-products/:id" element={<ProtectedRoute><Layout><EditProducts /></Layout></ProtectedRoute>} />
            <Route path="/home" element={<ProtectedRoute><Layout><Home /></Layout></ProtectedRoute>} />
            <Route path="/about" element={<ProtectedRoute><Layout><About /></Layout></ProtectedRoute>} />

            <Route path="/inquiry-management" element={<ProtectedRoute><Layout><Contact /></Layout></ProtectedRoute>} />
            <Route path="/contact-information" element={<ProtectedRoute><Layout><ContactInformation /></Layout></ProtectedRoute>} />
            <Route path="/list-category" element={<ProtectedRoute><Layout><ListCategory /></Layout></ProtectedRoute>} />
            <Route path="/add-category" element={<ProtectedRoute><Layout><AddCategory /></Layout></ProtectedRoute>} />
            <Route path="/edit-category/:id" element={<ProtectedRoute><Layout><EditCategory /></Layout></ProtectedRoute>} />
            <Route path="/view-category/:id" element={<ProtectedRoute><Layout><ViewCatgory /></Layout></ProtectedRoute>} />

            {/* brands */}
            <Route path="/list-brands" element={<ProtectedRoute><Layout><ListBrands /></Layout></ProtectedRoute>} />
            <Route path="/add-brands" element={<ProtectedRoute><Layout><AddBrands /></Layout></ProtectedRoute>} />
            <Route path="/edit-brands/:id" element={<ProtectedRoute><Layout><EditBrands /></Layout></ProtectedRoute>} />
            <Route path="/view-brands/:id" element={<ProtectedRoute><Layout><ViewBrands /></Layout></ProtectedRoute>} />

            {/* general settings */}
            <Route path="/general-settings" element={<ProtectedRoute><Layout><GeneralSettings /></Layout></ProtectedRoute>} />
            <Route path="/footer-settings" element={<ProtectedRoute><Layout><FooterSettings /></Layout></ProtectedRoute>} />

            {/* orders */}
            <Route path="/order-list" element={<ProtectedRoute><Layout><ListOrder /></Layout></ProtectedRoute>} />
            <Route path="/view-order/:id/:orderid" element={<ProtectedRoute><Layout><ViewOrder /></Layout></ProtectedRoute>} />

            {/* Customers */}
            <Route path="/customer-list" element={<ProtectedRoute><Layout><ListCustomers /></Layout></ProtectedRoute>} />
            <Route path="/view-customer/:id" element={<ProtectedRoute><Layout><ViewCustomers /></Layout></ProtectedRoute>} />

            {/* payment settings */}
            <Route path="/paymentmethod-list" element={<ProtectedRoute><Layout><PaymentMethodList /></Layout></ProtectedRoute>} />
            <Route path="/add-payment-methods" element={<ProtectedRoute><Layout><PaymentMthodAdd /></Layout></ProtectedRoute>} />

            {/* stock management */}
            <Route path="/list-stock-items" element={<ProtectedRoute><Layout><StockList /></Layout></ProtectedRoute>} />
            <Route path="/update-stock-items/:id" element={<ProtectedRoute><Layout><StockAdd /></Layout></ProtectedRoute>} />

            {/* pages */}
            <Route path="/home-banner-list" element={<ProtectedRoute><Layout><HomeBannerList /></Layout></ProtectedRoute>} />
            <Route path="/home-banner-add" element={<ProtectedRoute><Layout><HomeBannerAdd /></Layout></ProtectedRoute>} />
            <Route path="/home-banner-view/:id" element={<ProtectedRoute><Layout><HomeBannerView /></Layout></ProtectedRoute>} />
            <Route path="/home-banner-edit/:id" element={<ProtectedRoute><Layout><HomeBannerEdit /></Layout></ProtectedRoute>} />

            <Route path="/other-banner-list" element={<ProtectedRoute><Layout><OtherBannerList /></Layout></ProtectedRoute>} />
            <Route path="/other-banner-add" element={<ProtectedRoute><Layout><OtherbannerAdd /></Layout></ProtectedRoute>} />
            <Route path="/other-banner-view/:id" element={<ProtectedRoute><Layout><OtherBannerView /></Layout></ProtectedRoute>} />
            <Route path="/other-banner-edit/:id" element={<ProtectedRoute><Layout><OtherBannerEdit /></Layout></ProtectedRoute>} />

            {/* coupons */}
            <Route path="/coupon-list" element={<ProtectedRoute><Layout><CouponList /></Layout></ProtectedRoute>} />
            <Route path="/coupon-add" element={<ProtectedRoute><Layout><AddCoupon /></Layout></ProtectedRoute>} />
            <Route path="/coupon-view/:id" element={<ProtectedRoute><Layout><CouponView /></Layout></ProtectedRoute>} />
            <Route path="/coupon-edit/:id" element={<ProtectedRoute><Layout><EditCoupon /></Layout></ProtectedRoute>} />

            {/* Homesections */}
            <Route path="/home-section-list" element={<ProtectedRoute><Layout><HomeSectionList /></Layout></ProtectedRoute>} />
            <Route path="/home-section-add" element={<ProtectedRoute><Layout><HomeSectionAdd /></Layout></ProtectedRoute>} />
            <Route path="/home-section-view/:id" element={<ProtectedRoute><Layout><HomeSectionView /></Layout></ProtectedRoute>} />
            <Route path="/home-section-edit/:id" element={<ProtectedRoute><Layout><HomeSectionEdit /></Layout></ProtectedRoute>} />

            {/* about */}

            <Route path="/about-banner-list" element={<ProtectedRoute><Layout><AboutBannerEdit /></Layout></ProtectedRoute>} />
            <Route path="/about-banner-view" element={<ProtectedRoute><Layout><AboutBannerView /></Layout></ProtectedRoute>} />
            <Route path="/about-banner-view" element={<ProtectedRoute><Layout><AboutBannerView /></Layout></ProtectedRoute>} />

            <Route path="/about-section-view" element={<ProtectedRoute><Layout><AboutSectionView /></Layout></ProtectedRoute>} />
            <Route path="/about-section-edit" element={<ProtectedRoute><Layout><AboutSectionEdit /></Layout></ProtectedRoute>} />
            <Route path="/about-section-list" element={<ProtectedRoute><Layout><AboutSectionList /></Layout></ProtectedRoute>} />
            <Route path="/about-section-add" element={<ProtectedRoute><Layout><AboutSectionAdd /></Layout></ProtectedRoute>} />

            {/* contact */}
            <Route path="/contact-add" element={<ProtectedRoute><Layout><ContactAdd /></Layout></ProtectedRoute>} />

            <Route path="/product-detail-add" element={<ProtectedRoute><Layout><ProductDetailAdd /></Layout></ProtectedRoute>} />

            <Route path="/enable-guest-checkout" element={<ProtectedRoute><Layout><EnableGuestCheckout /></Layout></ProtectedRoute>} />
            <Route path="/add-best-seller" element={<ProtectedRoute><Layout><AddBestSeller /></Layout></ProtectedRoute>} />
            <Route path="/featured" element={<ProtectedRoute><Layout><AddFeatured /></Layout></ProtectedRoute>} />
            <Route path="/latest-product" element={<ProtectedRoute><Layout><AddLatestProduct /></Layout></ProtectedRoute>} />
            <Route path="/edit-customer/:id" element={<ProtectedRoute><Layout><EditCustomer /></Layout></ProtectedRoute>} />

            <Route path="/enable-disable-brand" element={<ProtectedRoute><Layout><EnableDisableBrand /></Layout></ProtectedRoute>} />
            <Route path="/privacy-policy" element={<ProtectedRoute><Layout><PrivacyPolicy /></Layout></ProtectedRoute>} />
            <Route path="/terms-and-conditions" element={<ProtectedRoute><Layout><TermsandConditions /></Layout></ProtectedRoute>} />
            <Route path="/edit-profile" element={<ProtectedRoute><Layout><AdminProfileUpdate /></Layout></ProtectedRoute>} />
            <Route path="/change-password" element={<ProtectedRoute><Layout><ChangePassword /></Layout></ProtectedRoute>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/send-otp" element={<SendOTP />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/order-settings" element={<ProtectedRoute><Layout><OrderSettings /></Layout></ProtectedRoute>} />
            <Route path="/add-varients" element={<ProtectedRoute><Layout><AddVarients /></Layout></ProtectedRoute>} />
            <Route path="/list-varients" element={<ProtectedRoute><Layout><ListVarients /></Layout></ProtectedRoute>} />
            <Route path="/edit-varients/:id" element={<ProtectedRoute><Layout><EditVarients /></Layout></ProtectedRoute>} /> 

             <Route path="/add-varients-by-product/:productId" element={<ProtectedRoute><Layout><AddVarientsbyProduct /></Layout></ProtectedRoute>} />
            <Route path="/list-varients-by-product/:productId" element={<ProtectedRoute><Layout><ListVarientsbyProduct /></Layout></ProtectedRoute>} />
            <Route path="/edit-varients-by-productid/:productId" element={<ProtectedRoute><Layout><EditVarientsbyProduct /></Layout></ProtectedRoute>} />   


            <Route path="/edit-varients-by-productid/:productId" element={<ProtectedRoute><Layout><EditVarientsbyProduct /></Layout></ProtectedRoute>} />


            <Route path="/refund-policy" element={<ProtectedRoute><Layout><RefundPolicy /></Layout></ProtectedRoute>} />
            <Route path="/shipping-policy" element={<ProtectedRoute><Layout><ShippingPolicy /></Layout></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Layout><Reports /></Layout></ProtectedRoute>} />
            <Route path="/update-currency" element={<ProtectedRoute><Layout><UpdateCurrency /></Layout></ProtectedRoute>} />

        </Routes>
    );
}

export default route;
